<template>
	<PortfolioPerformanceReturnJumboChip
		:return-data="props.returnData"
		:selected-chip="props.selectedChip"
		:show-return-indicator="props.showReturnIndicator"
		class="vcx-performance-return-jumbo-chip-wrapper"
		@return-chip-selected="emit('return-chip-selected', $event)"
	/>
</template>

<script setup lang="ts">
import { PerformanceReturnJumboChip, PerformanceReturnJumboChipEnum } from 'types/performance-portfolio';
import PortfolioPerformanceReturnJumboChip from '@components/account/portfolio/portfolio-performance-return-jumbo-chip.vue';

interface Props {
	returnData: PerformanceReturnJumboChip;
	selectedChip: PerformanceReturnJumboChipEnum;
	showReturnIndicator?: boolean;
}

interface Emits {
	(e: 'return-chip-selected', value: PerformanceReturnJumboChipEnum): void;
}

const props = withDefaults(defineProps<Props>(), {
	showReturnIndicator: true
});

const emit = defineEmits<Emits>();
</script>

<style lang="scss" scoped>
.vcx-performance-return-jumbo-chip-wrapper {
	:deep(.performance-return-jumbo-chip) {
		border: 1px solid var(--vcx-gray-50);
		border-radius: var(--vcx-radius-50);

		&:hover,
		&.active {
			border: 1px solid var(--vcx-gray-20);
			background: var(--vcx-gray-80);
		}

		p:first-child {
			color: var(--vcx-gray-40);
		}

		p:last-child {
			font-size: var(--vcx-font-size-body-lg);
			line-height: var(--vcx-line-height-body-lg);
			font-weight: 700;
			color: var(--vcx-gray-white);
			text-align: right;
			margin-top: 0;
		}
	}
}
</style>
